import { Entity } from '@adornis/baseql/decorators.js';
import { KooperationsPartner } from './KooperationsPartner.js';
import { Partner } from './Partner.js';

/**
 * @entity GovernmentOffice
 */

@Entity()
export class GovernmentOffice extends Partner {
  public static override _class = 'GovernmentOffice';

  public override get type() {
    return KooperationsPartner.GOVERNMENT_OFFICE;
  }
}
